// Een tab toont óf een lijst (entiteiten met footer/CRUD) óf een paneel
// (statische inhoud zoals een configuratieformulier, zonder lijst/footer).
// Deze discriminant maakt dat onderscheid expliciet in het type-systeem, zodat
// een paneel-tab geen lijst-velden (searchFields/requestName) hoeft te verzinnen.
export const tabKind = {
    list: 'list',
    panel: 'panel',
} as const;

export type TTabKind = (typeof tabKind)[keyof typeof tabKind];
